let notificationTypes = {
    attendance: 1000,
    timesheet: 1001,
    attendance_corrections: 1002,
    timeoff: 1003,
    overtime: 1004,
    fiscal_periods: 2000,
    cutoff: 2001,
    cutoff_settings: 2002,
    workdays: 2003,
    workshifts: 2004,
    myprofile: 3000,
    teams: 3001,
    project_details: 4000,
    task_details: 4001,
    charges_details: 4002,
    paygrades: 5000,
    allocation: 5001,
    payroll_summary: 6000,
    payroll_details: 6001,
    manual_adjustments: 6002,
    annualization_summary: 6003,
    annualization_details: 6004,
    sss_contributions: 6005,
    pagibig_contributions: 6006,
    philhealth_contributions: 6007,
    loan_payments: 7000,
    loan_payment_schedule: 7001,
    cash_advances: 7002,
    reimbursements: 7003,
    company_account: 8000,
    access_permissions: 8001,
    leave_types: 8002,
    holiday_summary: 8003,
    holiday_details: 8004,
    upload_attendance: 8005
}

export default notificationTypes